import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles(() => {
    return {
        root: { paddingLeft: '16px' },
        captionFont: { fontSize: '12px' },
        captionInfoContainer: { height: '26px' },
        captionTooltip: { margin: '0 0 0 4px' },
        captionInfoIcon: {
            width: '18px',
            height: '18px'
        }
    };
});